import { Icon, IconProps } from '~/global/components/icon/Icon';
import { View } from 'react-native';
import { cn } from '@/lib/utils';

export interface DropdownMenuItemIconProps extends IconProps {}

export const DropdownMenuItemIcon = ({
  className,
  ...props
}: DropdownMenuItemIconProps) => {
  return (
    <View className="p-1">
      <Icon {...props} className={cn(className, 'w-4 h-4')} />
    </View>
  );
};
